import React from 'react';

import AddProductButton from '../../../../../../components/add-product-button/add-product-button';
import NeedItNow from '../../../../../../components/need-it-now/need-it-now';
import ProductQuantity from '../../../../../../components/product-quantity/product-quantity';

import { useMyStore } from '../../../../../../shared/hooks/hooks';

import { getPrioritizedArticleStatusProduct } from '../../../../../../shared/utils/product/product';

import {
  BundleData,
  ProductItem
} from '../../../../../../shared/types/product';

import './product-list-package-card-actions.scss';

interface ProductListPackageCardActionsProps {
  defaultQuantity: number;
  onAddProductClick: (productItem: ProductItem) => void;
  onQuantityChange: (value: number) => void;
  prebuiltPackage: BundleData;
  quantity: number;
  totalQuantity: number;
}

function ProductListPackageCardActions(
  props: ProductListPackageCardActionsProps
) {
  const {
    defaultQuantity,
    onAddProductClick,
    onQuantityChange,
    prebuiltPackage,
    quantity,
    totalQuantity
  } = props;

  const { myStore } = useMyStore();

  const articleStatusProduct = getPrioritizedArticleStatusProduct(
    prebuiltPackage?.product1,
    prebuiltPackage?.product2
  );
  const { addToCartDisabled } = articleStatusProduct;
  const showAddToCart = !addToCartDisabled;

  function handleQuantityChange(e, updatedValue) {
    onQuantityChange(updatedValue);
  }

  return (
    <div styleName="container">
      {showAddToCart && (
        <>
          <div styleName="buy">
            <ProductQuantity
              defaultValue={defaultQuantity}
              onBlur={handleQuantityChange}
              onChange={handleQuantityChange}
              showLabel
              value={quantity}
            />

            <AddProductButton
              onClick={onAddProductClick}
              productItem={{ prebuiltPackage, quantity, totalQuantity }}
              styleName="add-to-btn"
            />
          </div>

          <div styleName="need-it-now">
            <NeedItNow isPrebuiltPackage phone={myStore?.address?.phone} />
          </div>
        </>
      )}
    </div>
  );
}

export default ProductListPackageCardActions;
